import React from 'react'
import ReactToggle from 'react-toggle'

class Toggle extends React.Component {
  static propTypes = {
    onChange: React.PropTypes.func,
    checkedLink: React.PropTypes.object,
    value: React.PropTypes.bool,
    label: React.PropTypes.string
  }

  onChange (evt) {
    // Dispatch to caller onChange if present
    if (this.props.onChange) {
      this.props.onChange(evt)
    }

    if (this.props.checkedLink) {
      this.props.checkedLink.requestChange(evt.target.checked)
    }
  }

  render() {
    const { checkedLink, label, ...other } = this.props
    let { value } = this.props

    value = value || (checkedLink && checkedLink.value) || false
    if (value && value.toJS) value = value.toJS()

    return (
      <div className="checkbox">
        <label>
          <ReactToggle
            onChange={::this.onChange}
            defaultChecked={value}
            {...other}
          />
          <span className="react-toggle-span">{label}</span>
        </label>
      </div>
    )
  }
}

export default Toggle



// WEBPACK FOOTER //
// ./modules/shared/components/toggle.js